import { render, staticRenderFns } from "./addExamDialog.vue?vue&type=template&id=1638ea96&scoped=true&"
import script from "./addExamDialog.vue?vue&type=script&lang=js&"
export * from "./addExamDialog.vue?vue&type=script&lang=js&"
import style0 from "./addExamDialog.vue?vue&type=style&index=0&id=1638ea96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1638ea96",
  null
  
)

export default component.exports